import request from '@/utils/request'

// ===============追溯码管理================

// 获取追溯码列表
// 接口：/yzdservice/enterprise/sdfmzsm/list (POST)
export function getZsmglList(data) {
  return request({
    method: 'post',
    url: '/yzdservice/enterprise/sdfmzsm/list',
    data: data
  })
}

// 获取单位和联系人信息
// 接口：/yzdservice/enterprise/sdfmzsm/getDwxx (GET)
export function getDwxx() {
  return request({
    method: 'get',
    url: '/yzdservice/enterprise/sdfmzsm/getDwxx'
  })
}

// 获取RFID厂商下拉
// 接口：/yzdservice/enterprise/sdfmzsm/getBqcsInfo (GET)
export function getBqcsInfo() {
  return request({
    method: 'get',
    url: '/yzdservice/enterprise/sdfmzsm/getBqcsInfo'
  })
}

// 新增保存
// 接口：/yzdservice/enterprise/sdfmzsm/addSave (POST)
export function addZsmgl(data) {
  return request({
    method: 'post',
    url: '/yzdservice/enterprise/sdfmzsm/addSave',
    data: JSON.parse(JSON.stringify(data))
  })
}

// 获取详情
// 接口：/yzdservice/enterprise/sdfmzsm/detail/{id} (GET)
export function getZsmglDetail(id) {
  return request({
    method: 'get',
    url: `/yzdservice/enterprise/sdfmzsm/detail/${id}`
  })
}

// 根据申请数据主键下载
// 接口：/yzdservice/enterprise/sdfmzsm/exportAllBySqid/{id} (GET)
export function exportAllBySqid(id) {
  return request({
    method: 'get',
    url: `/yzdservice/enterprise/sdfmzsm/exportAllBySqid/${id}`,
    responseType: 'blob'
  })
}

// 根据化学品子表批量下载
// 接口：/yzdservice/enterprise/sdfmzsm/exportByIds (POST)
export function exportByIds(data) {
  console.log(data, 222)
  return request({
    method: 'post',
    url: '/yzdservice/enterprise/sdfmzsm/exportByIds',
    data: data,
    responseType: 'blob'
  })
}

// ===============追溯码管理end================